import { Trans } from '@lingui/macro';
import {
    VIRTUAL_MACHINE_LIST_DATA_SOURCE,
    VIRTUAL_MACHINES_ADMIN_LIST_DATA_TABLE_ID,
    VIRTUAL_MACHINES_ADMIN_LIST_EMPTY_STATE_MESSAGE,
} from '../InfrastructureConstants';
import InfrastructureListSelector from './InfrastructureListSelector';
import { useInfrastructureListConfig } from '../InfrastructureListSelectorUtils';

const DEFAULT_EMPTY_MESSAGE = 'No virtual machines available';
const FALLBACK_TABLE_ID = 'virtual-machine-list-fallback';

/**
 * Displays a list of virtual machines for a hypervisor with enable/disable actions
 * Wraps InfrastructureListSelector with virtual machine-specific configuration
 */
const VirtualMachineListSelector = () => {
    const { url, tableId, emptyMessage } = useInfrastructureListConfig({
        dataSource: VIRTUAL_MACHINE_LIST_DATA_SOURCE,
        tableId: VIRTUAL_MACHINES_ADMIN_LIST_DATA_TABLE_ID,
        emptyMessage: VIRTUAL_MACHINES_ADMIN_LIST_EMPTY_STATE_MESSAGE,
        fallbackTableId: FALLBACK_TABLE_ID,
        defaultEmptyMessage: DEFAULT_EMPTY_MESSAGE,
    });

    return (
        <InfrastructureListSelector
            tableId={tableId}
            url={url}
            emptyStateMessage={emptyMessage}
            title={<Trans>Virtual Machines</Trans>}
        />
    );
};

export default VirtualMachineListSelector;
